// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyC9AM0RxAzGLGW8wWGEMbsqrbh0v8mq-nA",
  authDomain: "rancholicona.firebaseapp.com",
  projectId: "rancholicona",
  storageBucket: "rancholicona.firebasestorage.app",
  messagingSenderId: "215176777579",
  appId: "1:215176777579:web:d58daf09674f72d41ac62e"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);


// Exportar la base de datos Firestore para usarla en App.js
export const db = getFirestore(app);